export default __webpack_public_path__ + "static/media/lgroup1.800adc93.jpg";